import axios from 'axios';
import { reportError } from '@/lib/errorReporter';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const method = (error.config?.method || 'GET').toUpperCase();

    // Loguj wszystkie 5xx oraz network errors (no response).
    // Pomijaj 401/403/404/422 (to normalne biznesowe odpowiedzi) ORAZ sam endpoint logujący błędy (uniknięcie pętli).
    const isErrorLogEndpoint = url.includes('/errors/log');
    const shouldReport = !isErrorLogEndpoint && (
      !error.response || (status >= 500 && status <= 599)
    );
    if (shouldReport) {
      const serverMsg = error.response?.data?.detail || error.message || 'network error';
      const errorId = error.response?.data?.error_id;
      reportError({
        source: 'frontend',
        level: 'error',
        message: `API ${method} ${url} → ${status || 'NETWORK'}: ${typeof serverMsg === 'string' ? serverMsg : JSON.stringify(serverMsg)}`,
        path: window.location.pathname + window.location.search,
        method,
        status_code: status || null,
        context: {
          type: 'axios_response',
          api_url: url,
          backend_error_id: errorId,
          response_data: error.response?.data,
        },
      });
    }

    if (status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
